import React, {useEffect, useRef, useState} from "react";
import useFetch from "../../hooks/useFetch";
import Box from "@mui/material/Box";
import SelectField from "../../components/SelectField";
import {IconButton} from "@mui/material";
import {Delete} from "@mui/icons-material";
import TableView from "../../components/TableView";
import AlertBar from "../../components/AlertBar";
import {BASE_URL} from "../../constants";
import {reportErrors} from "../../helpers";

export default function QuestionAnswerMap(props) {
    const alert = useRef();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [data, setData] = useState({total: 0, data: []});
    const [showProgress, setShowProgress] = useState(false);

    const {data: answers} = useFetch("api/review-question-answer", {
        limit: 10,
    }, true, [], (response) => response.data.data.data.map(e => {
        return {value: e.answerId, label: e.name, ...e};
    }));

    useEffect(() => {
        loadData();
    }, [props?.item]);
    const loadData = () => {
        let url = `${BASE_URL}api/review-question-answer-mapping?questionId=${props.item?.questionId}`;
        window.axios
            .get(url)
            .then((response) => {
                setData(response.data.data)
            })
            .catch((error) => {
                reportErrors(alert.current, error);
            });
    };

    const submit = (answerId) => {
        let data = {answerId, questionId: props.item?.questionId}
        alert.current.showProgress();
        window.axios
            .post(`${BASE_URL}api/review-question-answer-mapping`, data)
            .then(response => {
                alert.current.showSuccess("Added Successfully.");
                setTimeout(() => {
                    loadData();
                }, 1000)
            })
            .catch(error => {
                reportErrors(alert.current, error);
            });
    }

    const remove = (item) => {
        alert.current.showProgress();
        window.axios
            .delete(`${BASE_URL}api/review-question-answer-mapping/${item.id}`, {})
            .then(response => {
                alert.current.showSuccess("Removed Successfully.");
                setTimeout(() => {
                    loadData();
                }, 1000)
            })
            .catch(error => {
                reportErrors(alert.current, error);
            });
    }

    return (
        <Box sx={{p: 1}}>
            <AlertBar ref={alert}/>
            <SelectField
                required={true}
                placeholder="Select Answer"
                options={answers}
                onChange={(value) => submit(value)}
            />
            <TableView
                showProgres={showProgress}
                url=""
                title="Questions Answers"
                columns={[
                    {
                        id: 'answer',
                        label: 'Answer',
                        minWidth: "x-larger",
                        customerRender: true,
                        valueGetter: (item) => (<>{item.answer?.name}</>)
                    },
                    {
                        id: 'action',
                        label: 'Action',
                        minWidth: "small",
                        disabled: true,
                        customerRender: true,
                        valueGetter: (item) => (
                            <IconButton size="small"
                                        onClick={() => remove(item)}><Delete/></IconButton>)
                    },
                ]}
                page={page}
                perPage={rowsPerPage}
                rows={data}
                rowClick={true}
                rowFunction={(item) => {
                }}
            />
        </Box>
    );
}